<template>
  <NavBar/>
  <HeroSection />
  <ProductsMarket />
  <OurLocation />
  <FarmEducation />
  <SiteFooter />
</template>

<script>
import NavBar from './NavBar.vue'
import SiteFooter from './SiteFooter.vue';
import HeroSection from './HeroSection.vue';
import ProductsMarket from './ProductsMarket.vue';
import OurLocation from './OurLocation.vue';
import FarmEducation from './FarmEducation.vue';

export default {
  name: 'HomePage',
  components: {
    NavBar,
    HeroSection,
    ProductsMarket,
    OurLocation,
    FarmEducation,
    SiteFooter
  }
}
</script>
